import type { RouteObject } from 'react-router';
import { adminRoutePatterns } from '@/admin-user/constants/routes';

export const adminRouteChildren: RouteObject[] = [
  {
    path: adminRoutePatterns.dashboard,
    lazy: () => import('@/admin-user/pages/dashboard-page').then((m) => ({ Component: m.DashboardPage })),
  },
  {
    path: adminRoutePatterns.evaluations,
    lazy: () =>
      import('@/evaluation/pages/admin-evaluations-page').then((m) => ({
        Component: m.EvaluationsPage,
      })),
  },
  {
    path: adminRoutePatterns.moduleDetails,
    lazy: () =>
      import('@/evaluation/pages/admin-module-details-page').then((m) => ({
        Component: m.ModuleDetailsPage,
      })),
  },
  {
    path: adminRoutePatterns.medias,
    lazy: () => import('@/media/pages/admin-medias-page').then((m) => ({ Component: m.AdminMediasPage })),
  },
  {
    path: adminRoutePatterns.articles,
    lazy: () =>
      import('@/media/pages/admin-articles-page').then((m) => ({
        Component: m.AdminArticlesPage,
      })),
  },
  {
    path: adminRoutePatterns.videos,
    lazy: () => import('@/media/pages/admin-videos-page').then((m) => ({ Component: m.AdminVideosPage })),
  },
  {
    path: adminRoutePatterns.trainings,
    lazy: () =>
      import('@/media/pages/admin-trainings-page').then((m) => ({
        Component: m.AdminTrainingsPage,
      })),
  },
  {
    path: adminRoutePatterns.agents,
    lazy: () => import('@/agent/pages/admin-agents-page').then((m) => ({ Component: m.AgentsPage })),
  },
  {
    path: adminRoutePatterns.users,
    lazy: () => import('@/admin-user/pages/users-page').then((m) => ({ Component: m.UsersPage })),
  },
  {
    path: adminRoutePatterns.userDetails,
    lazy: () => import('@/admin-user/pages/user-details-page').then((m) => ({ Component: m.UserDetailsPage })),
  },
  {
    path: adminRoutePatterns.institutions,
    lazy: () =>
      import('@/admin-institution/pages/admin-institutions-page').then((m) => ({
        Component: m.AdminInstitutionsPage,
      })),
  },
  {
    path: adminRoutePatterns.institutionDetails,
    lazy: () =>
      import('@/admin-institution/pages/admin-institution-details-page').then((m) => ({
        Component: m.AdminInstitutionDetailsPage,
      })),
  },
  {
    path: adminRoutePatterns.subscriptions,
    lazy: () =>
      import('@/subscription/pages/admin-subscriptions-page').then((m) => ({
        Component: m.SubscriptionsPage,
      })),
  },
  {
    path: adminRoutePatterns.sensoquizz,
    lazy: () =>
      import('@/admin-user/pages/sensoquizz-page').then((m) => ({
        Component: m.SensoquizzPage,
      })),
  },
  {
    path: adminRoutePatterns.mobileApp,
    lazy: () =>
      import('@/app-version/pages/mobile-app-page').then((m) => ({
        Component: m.MobileAppPage,
      })),
  },
  {
    path: adminRoutePatterns.changelog,
    lazy: () =>
      import('@/changelog/pages/changelog-page').then((m) => ({
        Component: m.ChangelogPage,
      })),
  },
];
